<template>
  
  <main>
    <section class="landingSection d-none d-lg-block">
      <div class="textOverlay pb-3">
        <h1 class="d-none d-lg-block" >Ihr IT-Consultant in Bayern</h1>
        <h1 class="d-lg-none" style="font-size: 3.2rem;">Ihr IT-Consultant in Bayern</h1>
        <h2 class="d-none d-lg-block" style="font-size: 2rem;">Digitalisierung in Deutschland: Vorwärts in die Zukunft</h2>
        <h2 class="d-lg-none" style="font-size: 1.4rem;">Digitalisierung in Deutschland: Vorwärts in die Zukunft</h2>
        <aside class="row row-cols-1 row-cols-md-5 justify-content-evenly">
          <div class="baseLink mt-4">
            <router-link to="/contact"
              class="gradient-button baseButton d-flex justify-content-center align-items-center">Kontaktiere
              uns!</router-link>
          </div>

          <div class="baseLink mt-4">
            <router-link to="/jobs"
              class="gradient-button baseButton d-flex justify-content-center align-items-center">Browse unsere
              Jobs</router-link>
          </div>
        </aside>
      </div>
    </section>

    <section class="landingSectionPhone d-lg-none">
      <div class="textOverlay pb-3">
        <h1 class="d-none d-lg-block" >Ihr IT-Consultant in Bayern</h1>
        <h1 class="d-lg-none" style="font-size: 3.2rem;">Ihr IT-Consultant in Bayern</h1>
        <h2 class="d-none d-lg-block" style="font-size: 2rem;">Digitalisierung in Deutschland: Vorwärts in die Zukunft</h2>
        <h2 class="d-lg-none" style="font-size: 1.4rem;">Digitalisierung in Deutschland: Vorwärts in die Zukunft</h2>
        <aside class="row row-cols-1 row-cols-md-5 justify-content-evenly">
          <div class="baseLink mt-4">
            <router-link to="/contact"
              class="gradient-button baseButton d-flex justify-content-center align-items-center">Kontaktiere
              uns!</router-link>
          </div>

          <div class="baseLink mt-4">
            <router-link to="/jobs"
              class="gradient-button baseButton d-flex justify-content-center align-items-center">Browse unsere
              Jobs</router-link>
          </div>
        </aside>
      </div>
    </section>
    
    <base-top></base-top>
    <div class="gap-lg"></div>
    <image-text-section id="aboutSection">
      <template v-slot:one>
        <img fetchpriority="high" src="@/assets/Sect1.webp" class="imagetext-img d-none d-lg-block" alt="Section 1 Image" />
        <img fetchpriority="high" src="@/assets/Sect1.webp" class="imagetext-img-phone d-lg-none" alt="Section 1 Image" />
      </template>
      <template v-slot:two>
        <h3 class="imagetext-headline ">Über Uns</h3>
        <about-text id="aboutText"></about-text>
      </template>
    </image-text-section>
    <div class="gap-lg"></div>
    <image-text-section id="missionSection">
      <template v-slot:two>
        <img src="@/assets/Sect2.webp" loading="lazy" class="imagetext-img d-none d-lg-block" alt="Section 2 Image" />
        <img src="@/assets/Sect2.webp" loading="lazy" class="imagetext-img-phone d-lg-none" alt="Section 2 Image" />
        <div class="gap-sm d-lg-none"></div>
        <h3 class="imagetext-headline d-lg-none">
          Mission
        </h3>
        <mission-text class="d-lg-none" id="missionText"></mission-text>
      </template>
      <template v-slot:one>
        <h3 class="imagetext-headline d-none d-lg-block text-center">Mission</h3>
        <mission-text id="missionText" class="d-none d-lg-block"></mission-text>
      </template>
    </image-text-section>


    <div class="gap-lg"></div>
    <image-text-section id="visionSection">
      <template v-slot:one>
        <img src="@/assets/Sec3.webp" loading="lazy" class="imagetext-img d-none d-lg-block" alt="Section 3 Image" />
        <img src="@/assets/Sec3.webp" loading="lazy" class="imagetext-img-phone d-lg-none" alt="Section 3 Image" />
      </template>

      <template v-slot:two>
        <h3 class="imagetext-headline">Vision</h3>
        <vision-text id="visionText"></vision-text>
      </template>
    </image-text-section>
    <div class="gap-lg"></div>

    <span id="scrollCheckpointOne" ref="statisticsection"></span>

    <statistic-section v-if="scrolledstatistic" class="apearAnimation" id="statisticSection"></statistic-section>
    <div v-else style="height: 750px; display: flex; justify-content: center"></div>
    <span id="scrollCheckpointTwo" ref="timelinesection"></span>

    <time-line v-if="scrolledtimeline" class="apearAnimation" id="timelineSection"></time-line>
    <div class="gap-lg"></div>
  </main>
</template>

<script>
import ImageTextSection from "@/components/templates/ImageTextSection.vue";
import MissionText from "@/components/outsource/MissionText.vue";
import VisionText from "@/components/outsource/VisionText.vue";
import AboutText from "@/components/outsource/AboutText.vue";
import BaseTop from "@/components/baseElems/BaseTop.vue";

import { defineAsyncComponent } from "vue";
const StatisticSection = defineAsyncComponent(()=>
  import ("@/components/sections/StatisticSection.vue")
)
const TimeLine = defineAsyncComponent(()=>
  import ("@/components/sections/TimeLine.vue")
)
export default {
  components: {
    ImageTextSection,
    MissionText,
    VisionText,
    AboutText,
    StatisticSection,
    TimeLine,
    BaseTop
  },
  data() {
    return {
      screenHeight: window.innerHeight,
      scrolledstatistic: false,
      scrolledtimeline: false,
    };
  },
  methods: {
    handleResize() {
      this.screenHeight = window.innerHeight;
    },
    checkStaticAnim() {
      const staticSection =
        this.$refs.statisticsection.getBoundingClientRect().bottom;
      this.handleResize()
      if (staticSection <= this.screenHeight) {
        this.scrolledstatistic = true;
      }
    },
    checkTimelineAnim() {
      const timelineSection =
        this.$refs.timelinesection.getBoundingClientRect().bottom;
      this.handleResize()
      if (timelineSection <= this.screenHeight) {
        this.scrolledtimeline = true;
      }
    },
    handlingScroll() {
      if (!this.scrolledstatistic) {
        this.checkStaticAnim();
      }
      if (!this.scrolledtimeline) {
        this.checkTimelineAnim();
      }
    },
  },
  mounted() {
    setTimeout(() => {
      window.addEventListener("scroll", this.handlingScroll);
    }, 1000);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handlingScroll);
  },
};
</script>

<style scoped>
a {
  min-width: 230px;
  height: 50px;
  font-size: 22px;
}
.landingSection{
  background-attachment: fixed;
  height: 700px;
  background-position: center center;
}
.landingSection,
.landingSectionPhone {
  height: 584px;
  background-image: url(@/assets/consulting.webp);
  background-repeat: no-repeat;
  background-size: cover;
  margin: 0;
  position: relative;
}
.textOverlay {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
  text-align: center;
  color: white;
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.2);
}
</style>
